// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"section-heading-module--sectionHeading--1jwEo"};